const TAMANHO_MAX_BYTES = 5 * 1024 * 1024;
const TAMANHO_MAX_PDF_BYTES = 10 * 1024 * 1024;
const MIME_IMAGEM = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
const MIME_PDF = 'application/pdf';

function lerArquivoComoDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Não foi possível ler o arquivo.'));
    reader.readAsDataURL(file);
  });
}

function carregarImagem(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Imagem inválida ou corrompida.'));
    img.src = dataUrl;
  });
}

function dataUrlParaBase64(dataUrl) {
  const partes = String(dataUrl).split(',');
  return partes.length > 1 ? partes[1] : partes[0];
}

function estimarBytesBase64(base64, mimeType) {
  const prefixo = mimeType === MIME_PDF ? /^data:application\/pdf;base64,/ : /^data:image\/[a-zA-Z0-9.+-]+;base64,/;
  const limpo = String(base64).replace(prefixo, '');
  return Math.ceil((limpo.length * 3) / 4);
}

async function redimensionarSeNecessario(dataUrl, maxLado = 1600, qualidade = 0.82) {
  const img = await carregarImagem(dataUrl);
  const maiorLado = Math.max(img.width, img.height);

  if (maiorLado <= maxLado) {
    return dataUrl;
  }

  const escala = maxLado / maiorLado;
  const largura = Math.round(img.width * escala);
  const altura = Math.round(img.height * escala);
  const canvas = document.createElement('canvas');
  canvas.width = largura;
  canvas.height = altura;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, largura, altura);

  return canvas.toDataURL('image/jpeg', qualidade);
}

function mimePermitido(file, permitePdf) {
  const mime = String(file.type || '').toLowerCase();
  if (MIME_IMAGEM.includes(mime)) return true;
  return permitePdf && mime === MIME_PDF;
}

export async function prepararAnexoDeArquivo(file, opcoes = {}) {
  const { permitePdf = false, tipoAnexo = 'FOTO' } = opcoes;

  if (!file || !mimePermitido(file, permitePdf)) {
    throw new Error(
      permitePdf
        ? 'Formato não suportado. Use JPG, PNG, WEBP ou PDF.'
        : 'Formato não suportado. Use JPG, PNG ou WEBP.',
    );
  }

  const ehPdf = String(file.type).toLowerCase() === MIME_PDF;
  const limite = ehPdf ? TAMANHO_MAX_PDF_BYTES : TAMANHO_MAX_BYTES;

  if (file.size > limite) {
    throw new Error(ehPdf ? 'O PDF excede o limite de 10 MB.' : 'A imagem excede o limite de 5 MB.');
  }

  let dataUrl = await lerArquivoComoDataUrl(file);
  let mimeType = String(file.type).toLowerCase();

  if (!ehPdf) {
    dataUrl = await redimensionarSeNecessario(dataUrl);
    mimeType = dataUrl.startsWith('data:image/png') ? 'image/png' : 'image/jpeg';
  }

  const base64 = dataUrlParaBase64(dataUrl);
  const tamanhoBytes = estimarBytesBase64(base64, mimeType);

  if (tamanhoBytes > limite) {
    throw new Error(ehPdf ? 'O PDF excede o limite de 10 MB.' : 'A imagem excede o limite de 5 MB após o processamento.');
  }

  return {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    preview: ehPdf ? null : dataUrl,
    eh_pdf: ehPdf,
    imagem_base64: base64,
    mime_type: mimeType,
    tamanho_bytes: tamanhoBytes,
    nome_original: file.name,
    tipo_anexo: ehPdf ? 'LAUDO' : tipoAnexo,
  };
}

export function ehAnexoPdf(anexo) {
  return (
    anexo &&
    (anexo.eh_pdf === true ||
      String(anexo.mime_type || '').toLowerCase() === MIME_PDF ||
      String(anexo.nome_original || '')
        .toLowerCase()
        .endsWith('.pdf'))
  );
}

export { TAMANHO_MAX_BYTES, TAMANHO_MAX_PDF_BYTES, MIME_PDF };
